import { render, staticRenderFns } from "./IconUpload.vue?vue&type=template&id=54b1c65a&"
import script from "./IconUpload.vue?vue&type=script&lang=ts&"
export * from "./IconUpload.vue?vue&type=script&lang=ts&"
import style0 from "./IconUpload.vue?vue&type=style&index=0&id=54b1c65a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports